import Banner, { BannerType } from '../../../common/Banner/Banner';
import Text from '../../../common/Text/Text';
import './Banners.scss';

const longMessage =
  'Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem ipsum is simply dummy text of the printing and typesetting industry.';

const types: { type: BannerType; label: string }[] = [
  { type: 'info', label: 'Information' },
  { type: 'success', label: 'Success' },
  { type: 'error', label: 'Error' },
  { type: 'alert', label: 'Alert' },
];

const Banners = () => (
  <div className="banners">
    {types.map(({ type, label }) => (
      <div className="line" key={type}>
        <div className="segment">
          <div className="title">
            <Text type="subheader">{`Banner - ${label} large`}</Text>
          </div>
          <div className="content">
            <Banner type={type} message={longMessage} />
            <Banner type={type} message={longMessage} dismissible={false} />
          </div>
        </div>
        <div className="segment">
          <div className="title">
            <Text type="subheader">{`Banner - ${label}`}</Text>
          </div>
          <div className="content">
            <Banner type={type} />
            <Banner type={type} dismissible={false} />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default Banners;
